import axiosPost from "./axiosPost";

export const SFHotelEmpleadoDel = async (
    params = {},
    credentials
) => {
    const body = {
        service: "SFHotelEmpleadoDel",
        params: {
            msuAdicionalId: params?.msuAdicionalId
        },
    };

    const result = await axiosPost(body, credentials);
    return result;
};
